import './taskLibrary.css';
import '@src/components/createFields/createFieldDrawer.css';
import React, { useEffect, useState } from 'react';
import { Alert, Tabs } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { TaskFilter } from './filters';
// import { GroupFilter } from '@src/pages/setting/dataFields/groupfilter';
import { ArcheiveTaskGrid } from './archiveTaskGrid';
import { GroupModal } from './group.modal';


import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { resetGroup } from '@src/middleware/redux/reducers/group.reducer';
import { useDispatch, useSelector } from 'react-redux';
import { LEGACY_GROUP_TENANT_ID } from '@src/util/constants/tenant.constants';
import { objectType } from '@src/util/types/object.types';
import { getAllTaskGroupQuery } from '../../util/query/taskgroup.query';
import { TaskGroupGrid } from './taskGroupGrid';
import { CreateTaskFieldDrawer } from '@src/components/createTask';
import { getAllTaskInLibrary } from '@src/util/query/taskInLibrary.query';
import { TaskLibraryGrid } from './taskLibraryGrid';
import { GridHeader } from "@src/components/tablegrid/header";
import dayjs from 'dayjs';




export const TaskLibrary=()=>{
    const  { TabPane } = Tabs;


    const [fieldModal, setFieldModal] = useState(false);
    const [taskToBeEdit, setTaskToBeEdit] = useState(null);
    const [groupmodal, setGroupModal] = useState(false);
    const [editGroup, setEditGroup] = useState(null);

    // Use URLSearchParams to parse the query string
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const myParam = query.get('field'); // Replace 'myParam' with your parameter name

    const navigate = useNavigate();

    useEffect(()=>{
        if(myParam){
            setObjectType(myParam && myParam[0].toUpperCase()+myParam.slice(1));
            const isObjectExist = Object.keys(objectType)?.includes(myParam[0].toUpperCase()+myParam.slice(1))
            if(!isObjectExist){
                navigate("/error");
            }
        }
    },[myParam]);

    // setting popover 
    
    const [group, setGroupInput] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [searchText, setSearchText] = useState("");


    // clear pagination
    useEffect(()=>{
        localStorage.removeItem('currPropPage');
    },[]);



    const { loading:groupLoading, data:groupList , refetch:groupRefetch } = useQuery(getAllTaskGroupQuery,{
        fetchPolicy: 'network-only'
    });

    const { loading:taskListLoading, data:taskList , refetch:taskListRefetch } = useQuery(getAllTaskInLibrary,{
        variables:{
            input: {
                groupId : group?.id || "",
                isArchived : false,
                customerId: selectedCustomer?.id
            }
        },
        fetchPolicy: 'network-only'
    });


    const { loading:archiveTaskListLoading, data:archiveTaskList , refetch:archiveTaskListRefetch } = useQuery(getAllTaskInLibrary,{
        variables:{
            input: {
                isArchived : true,
            }
        },
        fetchPolicy: 'network-only'
    });




    
    const [propertyList, setPropertyList] = useState([]);
    useEffect(()=>{
        if(taskList?.getAllTaskInLibrary?.response && !taskListLoading){
            setPropertyList(
                taskList?.getAllTaskInLibrary?.response?.map((task)=>({ 
                    ...task, 
                    groupName: task?.taskGroupDetail?.name,
                    createdBy: task?.employeeDetail?.firstname,
                    createdAt: dayjs(task?.createdAt).format("DD/MM/YYYY HH:mm")
                }))
            );
        }
    },[taskList?.getAllTaskInLibrary?.response, taskListLoading]);



   

    const [activeTab, setActiveTab] = useState('1');


    const dispatch = useDispatch();

    const tenantId = useSelector(state => state?.userAuthReducer?.authenticatedUserDetail?.tenantId);
    const isLegacyTenant = tenantId === LEGACY_GROUP_TENANT_ID;


    const handelTabChange = (e)=>{
        setActiveTab(e);
    }

    // task name + site name search (non-legacy tenants only)
    const filteredPropertyList = (!isLegacyTenant && searchText)
        ? propertyList?.filter((task)=>
            task?.label?.toLowerCase()?.includes(searchText.toLowerCase()) ||
            task?.siteDetails?.some((site)=>site?.sitename?.toLowerCase()?.includes(searchText.toLowerCase()))
        )
        : propertyList;

    useEffect(()=>{
        if(activeTab=="1"){
            taskListRefetch();
        }else if(activeTab=="3"){
            archiveTaskListRefetch();
        }
    },[activeTab]);



    return(
        <>
            <GridHeader
                title={"Task Library"}
                record={filteredPropertyList?.length}
                createAction={()=>{
                    activeTab=="1"? setFieldModal(true) :
                    setGroupModal(true)
                }} 
                actionBtnHide={false}
                btnText={activeTab=="1"? "Task" : "Task Group"}
            />


            <div className="setting-body" style={{maxWidth:'100%'}}>
                <div className="setting-body-inner">
                    <div className='setting-body-inner'>
                       

                        {/* propertie views */}
                        {/* <div className="propertyTab"></div> */}
                        <Tabs defaultActiveKey="1" className='grid-tabs' activeKey={activeTab} onChange={handelTabChange}>
                            <TabPane tab={`Task List (${taskListLoading? "Loading ..." :filteredPropertyList?.length || 0})`} key="1" onClick={taskListRefetch}>
                                <TaskFilter
                                    groupList={groupList?.getAllTaskLibraryGroup?.response}
                                    group={group}
                                    setGroup={setGroupInput}
                                    setSelectedCustomer={setSelectedCustomer}
                                    selectedCustomer={selectedCustomer}
                                    isLegacyTenant={isLegacyTenant}
                                    searchText={searchText}
                                    setSearchText={setSearchText}

                                />

                                <TaskLibraryGrid
                                    propertyList={filteredPropertyList}
                                    taskListRefetch={taskListRefetch}
                                    taskListLoading={taskListLoading || groupLoading}
                                    groupList={groupList?.getAllTaskLibraryGroup?.response}
                                    setFieldModal={setFieldModal}
                                    setTaskToBeEdit={setTaskToBeEdit}
                                    isLegacyTenant={isLegacyTenant}

                                />

                            </TabPane>


                            {isLegacyTenant &&
                            <TabPane tab="Task Group" key="2">

                                <TaskGroupGrid
                                    groupList={groupList?.getAllTaskLibraryGroup?.response}
                                    groupLoading={groupLoading}
                                    groupRefetch={groupRefetch}
                                    editGroup={(group)=>{setEditGroup(group); setGroupModal(true)}}
                                    setActiveTab={setActiveTab}
                                />
                            </TabPane>
                            }

                            <TabPane tab={`Archived Task`} key="3" onClick={()=>archiveTaskListRefetch()}>
                                {/* <ArcheiveFilter
                                    archive={archive}
                                    setArchive={setArchive}
                                    archivePopover={archivePopover}
                                    setArchivePopover={setArchivePopover}
                                    objectType={objectTypelocal}

                                /> */}
                                <Alert
                                    description={<b className='info-alert'>After 90 days these task will be deleted and can no longer be restored.</b>}
                                    type="info"
                                    closable
                                    closeText={<FontAwesomeIcon  className='alert-close-icon' icon={faTimes}/>}
                                />

                                <ArcheiveTaskGrid
                                    data={archiveTaskList?.getAllTaskInLibrary?.response?.map((res)=>({...res, group: res?.taskGroupDetail?.name}))}
                                    loading={ archiveTaskListLoading}
                                    refetch={()=>{}}
                                    taskListRefetch={archiveTaskListRefetch}
                                    isLegacyTenant={isLegacyTenant}

                                />
                            </TabPane>


                        </Tabs>

                        {/* filter */}
                        

                    </div>
                </div>
            </div>

            {
                fieldModal &&
                <CreateTaskFieldDrawer 
                    visible={fieldModal}  
                    objectType={"Task"}
                    taskListRefetch={taskListRefetch}
                    onClose={()=>{taskListRefetch(); groupRefetch(); setTaskToBeEdit(null); setFieldModal(false);}}
                    taskToBeEdit={taskToBeEdit}
                    selectedCustomer={selectedCustomer}
                />
            }
        
            
            

            
            <GroupModal 
                groupRefetch={groupRefetch} 
                objectType={"Task"}
                visible={groupmodal} 
                onClose={()=>{ setGroupModal(false); dispatch(resetGroup({})); setEditGroup(null); }} 
                group={editGroup}
            />


        </>
    );
};